module.exports = {
	"core": {
		"prune": 10000
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Presets/pruned.json
 ** module id = 46
 ** module chunks = 0
 **/